import { DOCUMENT } from '@angular/common';
import { Directive, Inject, Renderer2, RendererFactory2 } from '@angular/core';
import { DownloadFileCtx, FileLocation } from 'src/lib/fliko/models/http/downloadFile.data';
import { ImageInPreviewVM } from 'src/app/shared/interfaces/image-viewer.interface';
import { FireStorageService } from 'src/app/shared/services/storage.service';
import { ContextDataService } from 'src/app/view/user-context/services/context.data-service';

@Directive()
export abstract class BaseImageViewer {
  public downloading = false;

  protected renderer: Renderer2 | null = null;

  FileLocation = FileLocation;
  constructor(
    protected ctxDS: ContextDataService,
    protected storageService: FireStorageService,
    protected rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) protected document: Document
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  abstract get currentImage(): ImageInPreviewVM;

  abstract get isDefectDetailsView(): boolean;

  public download(): void {
    if (!this.currentImage?.fileLocation && !this.currentImage?.download?.location) return;
    this.downloading = true;
    const downloadCtx: DownloadFileCtx = {
      ...this.currentImage.download,
      storagePath: this.currentImage.path,
      fileUrl: null,
      location: this.currentImage.download?.location ?? this.currentImage.fileLocation!,
      estateId: this.currentImage.download?.estateId ?? this.ctxDS.peekCurrentEstateId()
    };
    this.storageService.getSignedUrl(downloadCtx).then((url) => this.triggerBrowserDownload(url));
    this.downloading = false;
  }

  private triggerBrowserDownload(url: string): void {
    if (!this.renderer || !url) return;
    const link = this.renderer.createElement('a');
    this.renderer.setAttribute(link, 'href', url);
    this.renderer.setAttribute(link, 'style', 'display:none');
    this.renderer.appendChild(this.document.body, link);
    link.click();
    this.renderer.removeChild(this.document.body, link);
  }
}
